import type { GaugeChartThresholdProps } from '../slots/Threshold.js';

export const findMatchingThreshold = (
  value: number,
  thresholdData: GaugeChartThresholdProps[],
): GaugeChartThresholdProps | undefined => {
  const filteredThresholdData = thresholdData.filter(
    (threshold) => value >= threshold.value,
  );

  if (!filteredThresholdData.length) {
    return undefined;
  }

  return filteredThresholdData.reduce(
    (final, current) => (current.value > final.value ? current : final),
    filteredThresholdData[0],
  );
};
